import React from "react"
import { Link } from "components"
import { FaWhatsapp } from "react-icons/fa"

const style = {
  position: "fixed",
  bottom: "24px",
  right: "24px",
  zIndex: 40,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "56px",
  height: "56px",
  borderRadius: "9999px",
  backgroundColor: "#25D366",
  color: "#fff",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.25)",
}

const FloatingWhatsapp = () => {
  return (
    <Link
      to="https://api.whatsapp.com/send?l=pt_BR&phone=5551996438118&text=Ol%C3%A1,%20como%20vai?!"
      aria-label="Fale conosco pelo WhatsApp"
      style={style}
    >
      <FaWhatsapp size={30} />
    </Link>
  )
}

export default FloatingWhatsapp
